import { CustomComponentProps } from "utils/types/general.types";
import SVG from "../core/SVG";

export type IncidentLocationProps = CustomComponentProps & {
    location: string;
};
const IncidentLocation = ({
    location,
    className,
    style
}: IncidentLocationProps) => {
    return (
        <div
            className={`incident-location flex justify-start items-center gap-2 pb-3 ${className}`}
            style={style}
        >
            <SVG svg="map-pointer" size={24} className="red-svg" />
            <span className="momeentoo-p white-text relative z-2">
                {location}
            </span>
        </div>
    );
};

export default IncidentLocation;
